module.exports = __webpack_public_path__ + "img/newsletterPingvin.0844a97b.svg";